<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <a class="navbar-item" href="#">
        <b>SpotiFork</b>
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>
